import { IonRow } from '@ionic/react';
import React from 'react';
import { NavLink } from 'react-router-dom';
// import { BRAND_NAME } from '../../constants/Branding';
// import Facebook from '../../assets/images/footer/Facebook.png';
// import Instagram from '../../assets/images/footer/Instagram.png';
// import Linkedin from '../../assets/images/footer/Linkedin.png';
// import Twitter from '../../assets/images/footer/Twitter.png';
import './Copyright.scss';

const Copyright: React.FC = () => {
  return (
    <div className="footer-ctn">
      <IonRow class="copyright-ctn">
        Copyrights 2023, Sky | All rights reserved, 
        <NavLink to="/rules" className="navlink web-view">
            Rules and Regulations
          </NavLink>
      </IonRow>
    </div>
  );
};

export default Copyright;
